<template>
<div class="loader_spinner loader-wrapper loader-wrapper-8">
    <div class="spinner">
        <div class="cube1"></div>
        <div class="cube2"></div>
    </div>
</div>	
</template>


<script>
export default {
  name: 'spinner',
  props: {
      visible: {
            type:Boolean
              }
  },
 watch : {
     
     visible : function(){
            var x = this;
         if (x.visible) {
           $(".loader_spinner").show(50);
         }
         if (!x.visible){
           $(".loader_spinner").hide(1000);
         }
         
     }   
 },
mounted : function (){
      
    setTimeout(function(){ $(".loader_spinner").hide(0);  }, 200);
}
    
}
</script>





// WEBPACK FOOTER //
// src/components/supportcomp/spinner.vue